module.exports = __webpack_public_path__ + "img/close.8bf21d63.svg";